import {LinkOptions, Options} from "../types";
import {createHttpLink} from "@apollo/client/core";
let currentOptions = {};
export const setOptions = (options:Options) => {
	// console.log(`Apollo options updates ${JSON.stringify(options)}`);
	currentOptions = options;
};
export const createHttpLinkServer = (url: string, fetch?:any) => {
	const {token, headers, role} = <Options>currentOptions;
	const linkOptions:any = <LinkOptions>{
		uri: `${url}`,
		headers: {
			...headers
		}
	};
	if (fetch) {
		linkOptions.fetch = fetch;
	}
	if (token) {
		linkOptions.credentials = "include";
		linkOptions.headers.authorization = `Bearer ${token}`;
	}
	if (role) {
		linkOptions.headers["x-hasura-role"] = role;
	}
	console.log(linkOptions);
	return createHttpLink(linkOptions);

};
